// Base styles
import * as staticRoot from "assets/components-static-styles/components/button/root";

const root = {
  ...staticRoot.default,
};

export default root;
